import {materials} from "./materials";


export const mathematicsMaterials = [
    {
        menuItemId: 7,
        materials: materials,
        links: [],
        tests: []
    }
]
